import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'

export interface AcademyTeaserState {
  isLoading: boolean
  lessonPreview: any
}

const initialState: AcademyTeaserState = {
  isLoading: false,
  lessonPreview: null
}

export const academyTeaserSlice = createSlice({
  name: 'academy-teaser',
  initialState,
  reducers: {
    resetAcademyTeaserState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(createEnrollment.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createEnrollment.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(createEnrollment.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(getLessonPreview.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getLessonPreview.fulfilled, (state, action) => {
        if (action.payload) state.lessonPreview = action.payload
        state.isLoading = false
      })
      .addCase(getLessonPreview.rejected, (state) => {
        state.isLoading = false
      })
})

export const { resetAcademyTeaserState } = academyTeaserSlice.actions

export default academyTeaserSlice.reducer

interface CreateEnrollmentParams {
  email: string
  programSlug: string
}

export const createEnrollment = createAsyncThunk(
  'create-enrollment',
  async ({ email, programSlug }: CreateEnrollmentParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.post('/api/v2/academy/enrollments', {
        programSlug,
        createPreview: true,
        enrollment: {
          patientAttributes: {
            email
          }
        }
      })

      return data.included?.[0]?.attributes?.videoPayload
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

interface GetLessonPreviewParams {
  token: string
}

export const getLessonPreview = createAsyncThunk(
  'get-lesson-preview',
  async ({ token }: GetLessonPreviewParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.get(`/api/v2/academy/lesson_previews/${token}`)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
